(function() {
    'use strict';
    angular
        .module('serviciosocialApp')
        .factory('TipoBaja', TipoBaja);

    TipoBaja.$inject = ['$resource', 'DateUtils'];

    function TipoBaja ($resource, DateUtils) {
        var resourceUrl =  'api/tipo-baja/:id';

        return $resource(resourceUrl, {}, {
            'all': { 
            	method: 'GET',
            	url:'api/tipo-baja-all',
            	isArray: true
           	},  
        });
    }
})();
